
import { useState, useEffect } from "react";
import axios from "axios";
import "./status.css"; // Importe o CSS correspondente
import image1 from "../assets/image-1.png";
import image2 from "../assets/image-2.png";
import imageHistorico from "../assets/imageHistorico.png";

import imageRelatorio from "../assets/imageRelatorio.png";
import loading_img from "../assets/loading.gif";


const Swal = require('sweetalert2')
import { useNavigate } from "react-router-dom";

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


const Status = () => {

  const navigate = useNavigate();
  const [idpedido, setIdPedido] = useState('');
  const [loading, setLoading] = useState(false);

  const [orderData, setOrderData] = useState({
    date: "-",
    status: "-",
    link: "-",
    initialQuantity: "-",
    contractedQuantity: "-",
    finalQuantity: "-",
    service: "-",
    service_id:""
  });

  const [historico_pedidos,setHistoricoPedidos]= useState([])



  useEffect(() => {
    dadosPedido()
  }, []);

  function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }


  const dadosPedido = async () => {
    const id = getParameterByName('id');
    setIdPedido(id);
  
    if (!id) {
      navigate('/');
      return;
    }
  
    // Verifica se os dados do pedido estão no localStorage
    let dados = await localStorage.getItem('@dados_pedido');
    const pedido_storage = await localStorage.getItem('@idpedido');
  
    if (!dados || pedido_storage !== id) {
      // Buscar dados da API se não encontrados no localStorage
      try {
        const options = {
          method: 'POST',
          url: 'https://apipedidos.com/painel/getPedidosRefill.php',
          headers: { 'Content-Type': 'application/json' },
          data: { token: '2a780f67128d8194c33e2ec3980061ab', idpedido: id },
        };
  
        const response = await axios(options);
        const resposta = response.data;
  
        if (!resposta.success) {
          toast.error(resposta.message);
          navigate('/');
          return;
        }
  
        // Armazena os dados no localStorage para uso futuro
        dados = resposta.data;
        localStorage.setItem('@dados_pedido', JSON.stringify(dados));
        localStorage.setItem('@idpedido', id);
      } catch (error) {
        console.error(error);
        toast.error('Erro ao buscar os dados do pedido. Tente novamente mais tarde.');
        navigate('/');
        return;
      }
    } else {
      // Dados já estavam no localStorage
      dados = JSON.parse(dados);
    }
  
    // Atualiza o estado com os dados do pedido
    const diahora = convertDate(dados.created);
    const quantidadeFinal = dados.start_count + dados.quantity;
  
    setOrderData({
      date: diahora,
      status: dados.status,
      link: dados.link,
      initialQuantity: dados.start_count,
      contractedQuantity: dados.quantity,
      finalQuantity: quantidadeFinal,
      service: dados.service_name,
      service_id: dados.service_id,
    });
  
    const getArrayHistorico = dados.historico_pedidos || [];
    setHistoricoPedidos(getArrayHistorico);
  };  


  function convertDate(dateTime) {

   // Converter a string em um objeto Date
   const dataOriginal = new Date(dateTime);

   // Subtrair 3 horas
   const novaData = new Date(dataOriginal.getTime() - 3 * 60 * 60 * 1000);

   // Formatar a data no formato DD/MM/YYYY HH:MM:SS
   const [year, month, day] = [
       novaData.getFullYear(),
       String(novaData.getMonth() + 1).padStart(2, "0"), // Mês é zero-indexado
       String(novaData.getDate()).padStart(2, "0")
   ];
   const [hours, minutes, seconds] = [
       String(novaData.getHours()).padStart(2, "0"),
       String(novaData.getMinutes()).padStart(2, "0"),
       String(novaData.getSeconds()).padStart(2, "0")
   ];

   return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
  }


  function corStatus(state) {
    if (state == "Pendente") {
      return "orange";
    }

    if (state == "Em andamento") {
      return "blue";
    }

    if (state == "Processando") {
      return "orange";
    }

    if (state == "Concluído") {
      return "green";
    }

    if (state == "Parcialmente concluído") {
      return "lightblue";
    }

    if (state == "Cancelado") {
      return "red";
    }

    if (state == "Erro") {
      return "red";
    }

    if (state == "Falha") {
      return "red";
    }

    return "gray"; // Cor padrão para status desconhecidos
  }

  const clickSolicitarReposicao = async ()=>{
 
    
    setLoading(true)

    const options = {
      method: 'POST',
      url: 'https://apipedidos.com/painel/solicitar_reposicao.php',
      headers: {'Content-Type': 'application/json'},
      data: {token: '6d808a40b79c1c6dc0dd1003f58d1c75', idpedido: idpedido}
    };

    try {
      var dados = await axios(options);
      setLoading(false)
 
      var resposta = dados.data;
      console.log(resposta)

      if(resposta.success == false){
        toast.error(resposta.message);
        return false;
      }


      Swal.fire({
        title: 'Sucesso!',
        text: resposta.message,
        icon: 'success',
      })

      

    } catch (error) {
        setLoading(false)
        console.log(error)
        toast.error('Encontramos um problema certifique sua conexão e tente mais tarde!');

    }
  }


  return (
    <>
      <ToastContainer />

      <div className="wrapper">


        <div className="inner">
         
          <div className="div2">

            <div className="table-container">
              <h2 style={{ marginBottom: 10 }}>Informações do Pedido</h2>
              <h2 style={{ marginBottom: 10, fontSize: 14 }}>#{idpedido}</h2>

              <table className="order-table">
                <tbody>
                  <tr>
                    <td>Data</td>
                    <td>{orderData.date}</td>
                  </tr>
                  <tr>
                    <td>Qtd. Inicial</td>
                    <td>{orderData.initialQuantity}</td>
                  </tr>
                  <tr>
                    <td>Qtd. Contratada</td>
                    <td>{orderData.contractedQuantity}</td>
                  </tr>
                  <tr>
                    <td>Qtd. Final</td>
                    <td>{orderData.finalQuantity}</td>
                  </tr>
                  <tr>
                    <td>Serviço</td>
                    <td>{orderData.service_id} - {orderData.service}</td>

                  </tr>
                  <tr>
                    <td>Status</td>
                    <td> <span style={{ backgroundColor: corStatus(orderData.status), padding: 7, borderRadius: 10, color: 'white' }}>{orderData.status}</span></td>
                  </tr>
                </tbody>
              </table>
              <div className="link-container">
                <strong>Link do Pedido:</strong>
                <a href={orderData.link} target="_blank" class="short-link">{orderData.link}</a>
              </div>
            </div>


            <div style={{ marginLeft: 10, marginRight: 10 }}>
              {loading == false && (<button type="submit" className="button2" onClick={()=>{clickSolicitarReposicao()}}>
                <span>Solicitar reposição</span>
              </button>)}

              {loading == true && (<button type="submit" className="button2">
                <img src={loading_img} alt="" style={{width:25,height:25}} />
              </button>)}
            </div>
          </div>


















   <br></br>
          <div className="div2">

<h2 style={{ marginBottom: 10, marginTop: 40 }}>Histórico de Reposição</h2>
<h2 style={{ marginBottom: 10, fontSize: 14 }}>#{idpedido}</h2>


<div className="table-container" style={{ height: 400,overflowY:'scroll'}}>
  
{historico_pedidos.map((i, index) => {
                            return ( <div style={{marginTop:10}}>
    <p style={{ backgroundColor: '#2b2b2b', fontSize: 15, padding: 10, borderRadius: 10, color: 'white' }}>Data: {convertDate(i.data)}

      <p style={{ backgroundColor: '#2b2b2b', fontSize: 15, borderRadius: 10, color: 'white', marginTop: 20 }}>Status: <span style={{ backgroundColor: corStatus(i.status_reposicao), padding: 7, borderRadius: 10, color: 'white' }}>{i.status_reposicao}</span></p>
     {i.quantidade_inserida != ''&&( <p style={{ backgroundColor: '#2b2b2b', fontSize: 15, borderRadius: 10, color: 'white', marginTop: 20 }}>Quantidade inserida: {i.quantidade_inserida}</p>)}

     {i.notas && i.notas != ''&&( <p style={{ backgroundColor: '#2b2b2b', fontSize: 15, borderRadius: 10, color: 'white', marginTop: 20 }}>Nota: {i.notas}</p>)}

  </p>
  </div>)})}

 


  

  


  

</div>


</div>

























          
        </div>




























      </div>


     
    </>
  );
};

export default Status;
